<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 核心价值
    </div>
    <div class="common_wrap">
      <img src="../../static/images/core.jpg" class="top_banner">
      <div class="about_lists">
        <div class="about_item">
          <p class="about_title">
            <span class="num">1</span>
            <span>帝景价值</span>
          </p>
          <div class="about_text">1、为私人豪宅、五星级酒店及高级会所项目提供一站式健康卫浴系统解决方案;<br>
2、12 年高端卫浴服务，专注、专业、全心全力;<br>
3、品牌授权一级代理，一线品牌，合理价格;<br>
4、专业流程跟踪服务，安装售后，全程无忧;<br>
5、帝景•构建幸福健康生活!Dking wellness</div>
        </div>
        <div class="about_item">
          <p class="about_title">
            <span class="num">2</span>
            <span>服务流程</span>
          </p>
          <div class="about_text"><img src="../../static/images/core_step.png"></div>
        </div>
        <div class="about_item">
          <p class="about_title">
            <span class="num">3</span>
            <span>售后保障</span>
          </p>
          <div class="about_text">
            <p class='core_link'>BISAZZA：<router-link to='/our/customer_s/1'>点击打开质保说明>></router-link></p>
            <p class='core_link'>卫浴：<router-link to='/our/customer_s/2' >点击打开质保说明>></router-link></p>
            <p class='core_link'>户外SPA：<router-link to='/our/customer_s/3' >点击打开质保说明>></router-link></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      isX:false
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .top_banner{
  margin-bottom: 72px;
 }
 .about_title{
  min-width: 98px;
  height: 42px;
  line-height: 42px;
  border-radius: 4px;
  background-color: #f8f7f7;
  color: #000000;
  font-size: 18px;
  margin-bottom: 30px;
  padding-right: 10px;
  display: inline-block;
 }
 .about_item{
  margin-bottom: 46px;
 }
 .num{
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  background-color: #3478f7;
  display: inline-block;
  margin-left: 7px;
 }
 .about_text{
  font-size: 14px;
  color: #000000;
  line-height: 200%;
 }
 .core_link{
  margin-bottom: 40px;
 }
 .core_link a{
  color: #3478f7;
 }
</style>


// WEBPACK FOOTER //
// src/components/core.vue